var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 3l2.163 4.608L17 8.351l-3.5 3.585.826 5.064L10 14.608 5.674 17l.826-5.064L3 8.351l4.837-.743z",
    transform: "translate(-3 -3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004884",
    d: "M10 5.353l-1.258 2.68c-.141.301-.424.513-.753.563l-2.915.448 2.141 2.193c.222.227.323.546.272.86l-.494 3.031 2.523-1.395c.15-.084.317-.125.484-.125.167 0 .333.041.484.125l2.523 1.395-.494-3.031c-.051-.314.05-.633.271-.86l2.142-2.193-2.915-.448c-.33-.05-.612-.262-.753-.563L10 5.353M10 3l2.163 4.608L17 8.35l-3.5 3.585.826 5.064L10 14.608 5.674 17l.826-5.064L3 8.35l4.837-.743L10 3z",
    transform: "translate(-3 -3)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.370596872f6a7586b4b859b5c3a05c69.svg";
export { ForwardRef as ReactComponent };